"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("./grid-config");
var _excluded = ["dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var breakpoints = Object.keys(_gridConfig.gridConfig);
var propTypes = _objectSpread(_objectSpread(_objectSpread({}, Object.fromEntries(breakpoints.map(function (b) {
  return [b, Number];
}))), Object.fromEntries(breakpoints.map(function (b) {
  return ["colStart-".concat(b), Number];
}))), {}, {
  dataTestId: _propTypes["default"].string
});
var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, Object.fromEntries(breakpoints.map(function (b) {
  return [b, null];
}))), Object.fromEntries(breakpoints.map(function (b) {
  return ["colStart-".concat(b), null];
}))), {}, {
  dataTestId: null
});

/*
 * Return the CSS that contains only the relevant breakpoints and column sizes for the grid item.
 * A column size is always defined for xxs even if not provided.
 */
var spanCols = function spanCols(props) {
  return breakpoints.filter(function (breakpoint) {
    return (props[breakpoint] || breakpoint === 'xxs') && props[breakpoint] > 0;
  }).map(function (breakpoint) {
    var _props$breakpoint;
    return breakpoint === 'xxs' ? "\n\t\t\t\t\tgrid-column: auto / span ".concat((_props$breakpoint = props[breakpoint]) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : 12, ";\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t") : "@media screen and (min-width: ".concat(_gridConfig.gridConfig[breakpoint].minWidth, ") {\n\t\t\t\t\tgrid-column: auto / span ").concat(props[breakpoint], ";\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t}");
  }).join('');
};

/*
 * Return the CSS that contains only the relevant grid-column-start values for the grid item.
 * Note: The naming of the colStart prop conforms to colStart-[breakpoint].
 */
var colStart = function colStart(props) {
  return breakpoints.filter(function (breakpoint) {
    return props["colStart-".concat(breakpoint)];
  }).map(function (breakpoint) {
    var colStartValue = props["colStart-".concat(breakpoint)];
    return breakpoint === 'xxs' ? "grid-column-start: ".concat(colStartValue, ";") : "@media screen and (min-width: ".concat(_gridConfig.gridConfig[breakpoint].minWidth, ") {\n\t\t\t\t\tgrid-column-start: ").concat(colStartValue, ";\n\t\t\t\t}");
  }).join('');
};
var StyledComponent = _styledComponents["default"].div.withConfig({
  displayName: "grid-item__StyledComponent",
  componentId: "sc-1c9n71y-0"
})(["grid-column:auto / span 12;display:none;", " ", ""], function (props) {
  return spanCols(props);
}, function (props) {
  return colStart(props);
});
var GridItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledComponent, _extends({
    "data-testid": dataTestId,
    ref: ref,
    className: "fuse-responsive-grid__item"
  }, props));
});
GridItem.propTypes = propTypes;
GridItem.defaultProps = defaultProps;
GridItem.displayName = 'GridItem';
var _default = exports["default"] = GridItem;